import defaultImage from "../assets/others/logo.png";

export const defaultChatBotSettings = {
    title: 'Botcircuits',
    subTitle: 'Built using Botcircuits',
    welcomeMessage: '',
    tips: [],
    inputPlaceHolder: 'Type a message...',
    logo: defaultImage,
    headerBackgroundColor: '#000000',
    headerTextColor: "#fff",
    chatWindowBackgroundColor: "#ffffff",
    sendBarBackgroundColor: '#f7f7f8',
    position: "bottom-right",
    launcherStyle: "bubble",
    textBarGlowEnabled: true,
    textBarGlowColor: '#3b82f6',
    showPoweredBy: true,
    intentLess: true
}
